import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ENUM__settings_user_tab } from '../_base/ENUM__settings_user_tab';
import { S_TAB__user_wrapper } from '../_base/S_TAB__user_wrapper';

export function TabSettingsUserCollections() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  return (
    <S_TAB__user_wrapper type={ENUM__settings_user_tab.COLLECTIONS}>
      <div className="settings-general-utitle-wrapper mt-0"></div>
    </S_TAB__user_wrapper>
  );
}
